// src/components/utils/AudioContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { soundManager } from './SoundManager';

const AudioContext = createContext();

export const useAudio = () => {
    return useContext(AudioContext);
};

export const AudioProvider = ({ children }) => {
    const [musicMuted, setMusicMuted] = useState(false);
    const [sfxMuted, setSfxMuted] = useState(false);

    useEffect(() => {
        // 1. Initialize immediately
        soundManager.init();

        // 2. Define the unlock handler
        const unlockAudio = () => {
            // Attempt to resume/unlock
            soundManager.resumeContext().then(() => {
                // Only remove listeners if we are TRULY running
                if (soundManager.isReady()) {
                    removeUnlockListeners();
                }
            }).catch(e => {
                console.warn("Audio unlock failed, will retry on next interaction", e);
            });
        };

        const removeUnlockListeners = () => {
            document.removeEventListener('touchstart', unlockAudio, true);
            document.removeEventListener('touchend', unlockAudio, true);
            document.removeEventListener('click', unlockAudio, true);
            document.removeEventListener('keydown', unlockAudio, true);
        };

        // 3. Attach listeners with CAPTURE phase (true)
        // 'touchend' is the specific fix for swipe interactions
        document.addEventListener('touchstart', unlockAudio, true);
        document.addEventListener('touchend', unlockAudio, true);
        document.addEventListener('click', unlockAudio, true);
        document.addEventListener('keydown', unlockAudio, true);

        return () => {
            removeUnlockListeners();
        };
    }, []);

    // ... Keep existing mute logic ...
    useEffect(() => {
        soundManager.setMusicMute(musicMuted);
    }, [musicMuted]);

    useEffect(() => {
        soundManager.setSfxMute(sfxMuted);
    }, [sfxMuted]);

    const value = {
        musicMuted,
        setMusicMuted,
        sfxMuted,
        setSfxMuted
    };

    return (
        <AudioContext.Provider value={value}>
            {children}
        </AudioContext.Provider>
    );
};